import { apiDeleteWarehouseHandlings, apiGetWarehouseHandlings, apiSetWarehouseHandling } from "api/warehouseApi";

  // const dispatch: any = useDispatch();
  // const store = useSelector((state: any) => state);
  // const token = store.businessReducer.business.token;
  // const pagination = store.paginationReducer;
  // // useEffect(() => {
  // //   dispatch(apiGetWarehouseHandlings({pagination, token }));
  // // }, [token]);

 export  const stockTaking = [
    {
      key: "stockTaking",
      label: "انبارگردانی",
      title: "انبارگردانی",
      description: "انبارگردانی",
      pluralLabel: "انبارگردانی ها",
      tableColumns: [
        { name: "کد", key: "id", filterParams: { column: "id", columnType: "string" } },
        { name: "تاریخ", key: "createdAt", filterParams: { column: "createdAt", columnType: "date" } },
        { name: "انبار", key: "warehouse" },
        { name: "توضیحات", key: "description" },
        { name: "وضعیت", key: "status" },
        { name: "پروژه", key: "project" },
        { name: "شعبه", key: "branch" },
      ],
      disableDateFilter: true,
      actions: {
        fetch: apiGetWarehouseHandlings,
        delete: apiDeleteWarehouseHandlings,
        edit: {},
      },
    },
  ];


